<template>
  <div class="home text-left mx-5 pb-4 mt-2">
    <div class="d-flex align-items-end justify-content-between">
      <div class="text-gray-500 text-3xl">
        Welcome!
      </div>
      <div>
        <div class="text-gray-400 font-weight-bold">{{superTitle}}</div>
        <div class="text-gray-500 text-2xl">{{title}}</div>
      </div>
    </div>
    <hr class="welcome-divider mt-4 mb-5" style="border-width: 2px;"/>
    <div class="position-relative w-100">
      <transition :name="transitionName">
        <router-view @getData="() => { getData() }" :summaryNumbers="summaryNumbers"
        class="position-absolute w-100" v-cloak/>
      </transition>
    </div>
  </div>
</template>

<script>
import { searchShipment, delayedShipment, unpaidShipment } from '../api/search';

export default {
  name: 'Home',
  data() {
    return {
      summaryNumbers: {
        delivered: {
          name: 'delivered',
          items: [
          ],
          increase: true,
        },
        delivering: {
          name: 'delivering',
          items: [
          ],
          increase: true,
        },
        toLoad: {
          name: 'to load',
          items: [
          ],
          increase: true,
        },
        pickups: {
          name: 'pickups',
          items: [
          ],
          increase: true,
        },
        unpaid: {
          name: 'unpaid',
          items: [
          ],
          increase: false,
        },
        delayed: {
          name: 'delayed',
          items: [
          ],
          increase: false,
        },
      },
      transitionName: 'fade',
      superTitle: 'Overview',
      title: 'Dashboard',
    };
  },
  methods: {
    getData() {
      searchShipment('pickup').then((res) => {
        this.summaryNumbers.pickups.items = res.data.results;
      }).catch((err) => {
        console.log(err);
      });
      searchShipment('toload').then((res) => {
        this.summaryNumbers.toLoad.items = res.data.results;
      }).catch((err) => {
        console.log(err);
      });
      searchShipment('todeliver').then((res) => {
        this.summaryNumbers.delivering.items = res.data.results;
      }).catch((err) => {
        console.log(err);
      });
      searchShipment('completed').then((res) => {
        this.summaryNumbers.delivered.items = res.data.results;
      }).catch((err) => {
        console.log(err);
      });
      delayedShipment().then((res) => {
        this.summaryNumbers.delayed.items = res.data.results;
      }).catch((err) => {
        console.log(err);
      });
      unpaidShipment().then((res) => {
        this.summaryNumbers.unpaid.items = res.data.results;
      }).catch((err) => {
        console.log(err);
      });
    },
    updateTitle(path) {
      switch (path.split('/').pop()) {
        case 'delivered':
          this.superTitle = 'Shipments';
          this.title = 'Delivered';
          break;
        case 'delivering':
          this.superTitle = 'Shipments';
          this.title = 'Delivering';
          break;
        case 'toload':
          this.superTitle = 'Shipments';
          this.title = 'To Load';
          break;
        case 'pickups':
          this.superTitle = 'Shipment';
          this.title = 'Pickups';
          break;
        case 'unpaid':
          this.superTitle = 'Shipments';
          this.title = 'Unpaid';
          break;
        case 'delayed':
          this.superTitle = 'Shipments';
          this.title = 'Delayed';
          break;
        default:
          this.superTitle = 'Overview';
          this.title = 'Dashboard';
      }
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      this.updateTitle(to.path);
    },
  },
  mounted() {
    this.updateTitle(this.$route.path);
    this.getData();
    // searchShipment('pickup').then((res) => {
    //   this.summaryNumbers.pickups.items = res.data.results;
    // }).catch((err) => {
    //   console.log(err);
    // });
    // searchShipment('toload').then((res) => {
    //   this.summaryNumbers.toLoad.items = res.data.results;
    // }).catch((err) => {
    //   console.log(err);
    // });
    // searchShipment('todeliver').then((res) => {
    //   this.summaryNumbers.delivering.items = res.data.results;
    // }).catch((err) => {
    //   console.log(err);
    // });
    // searchShipment('delivered').then((res) => {
    //   this.summaryNumbers.delivered.items = res.data.results;
    // }).catch((err) => {
    //   console.log(err);
    // });
    // delayedShipment().then((res) => {
    //   this.summaryNumbers.delayed.items = res.data.results;
    // }).catch((err) => {
    //   console.log(err);
    // });
    // unpaidShipment().then((res) => {
    //   this.summaryNumbers.unpaid.items = res.data.results;
    // }).catch((err) => {
    //   console.log(err);
    // });
  },
};
</script>

<style lang="scss">
.welcome-divider {
  border-color: var(--hover-color);
}

#feed .card {
  border: unset;
  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
}

.transparent-button {
  background: transparent !important;
  color: dimgray !important;
  border-radius: 5px 0 0 5px !important;
}

.transparent-button:hover {
  background: lightgray !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: opacity .5s, transform .5s;
}

.slide-left-enter, .slide-right-leave-to {
  opacity: 0;
  transform: translateX(200px);
}

.slide-left-leave-to, .slide-right-enter {
  opacity: 0;
  transform: translateX(-200px);
}
</style>
